const countryNameToISO = {
    "France": "FR",

    "Россия": "RU",
    "Russia": "RU",

    "Germany": "DE",
    "Deutschland": "DE",

    "Poland": "PL",
    "Polska": "PL",

    "Spain": "ES",
    "España": "ES",

    "United Kingdom": "GB",
    "UK": "GB"
};

export const getISOCodeFromCountryName = (countryName) => {
    if (!countryName) return "";
    const normalized = countryName.trim();
    return countryNameToISO[normalized] || "";
};
